import { PaymentState } from './payment-state.model';
import { PaymentHistory } from './payment-history.model';
import { TranslateService } from '@ngx-translate/core';

export class PaymentHistoryModel {
  DateTime: string;
  Description: string;
  AmountToPay: string;
  Currency: string;
  PaymentState: string;
  PaymentLink: string;
  PricePlanId: string;
  PricePlanName: string;
  PricePlanAppliedAt: string;

  constructor(
    private paymentHistory: PaymentHistory,
    public translate: TranslateService
  ) {
    const utcDate = new Date(
      Date.parse(paymentHistory.DateTime.toLocaleString())
    );
    this.DateTime =
      utcDate.toLocaleDateString() + ' ' + utcDate.toLocaleTimeString();
    this.Description = paymentHistory.Description;
    this.AmountToPay = (paymentHistory.AmountToPay / 100).toFixed(2);
    this.Currency = paymentHistory.Currency;
    this.PaymentLink = paymentHistory.PaymentLink;

    this.PaymentState = this.translate.instant(
      PaymentState[paymentHistory.PaymentState]
    );

    this.PricePlanId = paymentHistory.PricePlanId || '';
    this.PricePlanName = paymentHistory.PricePlanName || '';
    if (paymentHistory.PricePlanAppliedAt) {
      const appliedAtDate = new Date(
        Date.parse(paymentHistory.PricePlanAppliedAt.toLocaleString())
      );
      this.PricePlanAppliedAt =
        appliedAtDate.toLocaleDateString() +
        ' ' +
        appliedAtDate.toLocaleTimeString();
    } else {
      this.PricePlanAppliedAt = '';
    }
  }
}
